import {PROJECT_LIST_CONFIG} from "../../views/list/@config"
import {PROJECT_BOARD_CONFIG} from "../../views/board/@config"
import {PROJECT_TABLE_CONFIG} from "../../views/table/@config"
import {PROJECT_CALENDAR_CONFIG} from "../../views/calendar/@config"
import {PROJECT_GANTT_CONFIG} from "../../views/gantt/@config"
import {PROJECT_WORKLOAD_CONFIG} from "../../views/workload/@config"
import {CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG} from "../../views/events-summary/@config"
import {CUSTOM_VIEW_EXPENSES_CONFIG} from "../../views/expenses/@config-custom"
import {PROJECT_ACTIVITY_CONFIG} from "../../views/activity/@config"
import {CUSTOM_VIEW_WHATS_DONE_CONFIG} from "../../views/whats-done/@config"
import {CUSTOM_VIEW_PASTDUE_CONFIG} from "../../views/pastdue/@config"
import {CUSTOM_VIEW_PRIORITIES_CONFIG} from "../../views/priorities/@config"
import {CUSTOM_VIEW_ACTION_REQUIRED_CONFIG} from "../../views/action-required/@config"
import {CUSTOM_VIEW_TASKS_BY_USER_CONFIG} from "../../views/tasks-by-user/@config"
import {PROJECTS_PORTFOLIO_CONFIG} from "../../views/portfolio/@config"
import {PROJECTS_PROJECTS_LIST_CONFIG} from "../../views/projects-list/@config"
import {CUSTOM_VIEW_DASHBOARD_CONFIG} from "../../views/dashboard/@config";
import {ItemIcon} from "./item-icon/item-icon";

export enum ProjectAccess {
    READ_ONLY   = -10,
    // READ_ONLY_WITH_COMMENT= -9, // just reserve
    CLIENT      = -5,

    LIMITED     = 1,
    STANDARD    = 2,
    FULL        = 3
}

export const ProjectAccessLabelDictionary : any = {
    [ProjectAccess.FULL]               : 'Full',
    [ProjectAccess.STANDARD]           : 'Standard',
    [ProjectAccess.LIMITED]            : 'Limited',
    [ProjectAccess.CLIENT]             : 'Customer',
    [ProjectAccess.READ_ONLY]          : 'Read only',
}

export const ProjectAccessDescriptionDictionary : any = {
    [ProjectAccess.FULL]               : 'Access to all data and management options, suitable for managers.',
    [ProjectAccess.STANDARD]           : 'View all work items but no access to settings or user management.',
    [ProjectAccess.LIMITED]            : 'View only specific folders and tasks they’ve been added to.',
    [ProjectAccess.CLIENT]             : '',
    [ProjectAccess.READ_ONLY]          : 'View all projects and tasks without editing rights.',
}

export const WorkspaceAccessDescription: { [key: number]: string } = {
    [ProjectAccess.FULL]            : 'Can manage workspace settings, invite users, and create workspace views.',
    [ProjectAccess.STANDARD]        : 'Has access to workspace resources but cannot change settings or invite users.',
    [ProjectAccess.LIMITED]         : 'Access level not supported.',
    [ProjectAccess.CLIENT]          : 'Access level not supported.',
    [ProjectAccess.READ_ONLY]       : 'Access level not supported.',
}

export enum UserInheritance {
    MANUAL      = 0,
    INHERITED   = 1,
    UPHERITED   = 2     // not in use ?
}

export enum ProjectRole {
    CLIENT          = 1,
    GUEST           = 2,
    USER            = 3,
    PROJECT_MANAGER = 4,
    OWNER           = 5
}

// see const ItemIcon
// to add new - add to
// ProjectIconsOptionsList, - eto options
// a eche nado add to ii ?


export const ProjectIconDictionary : DictionaryStringString = ItemIcon

// export const ProjectIconDictionary : DictionaryStringString = {
//
//     // Dobavlen tolko dlya reports
//     report              : 'i5-chart-bar',
//
//     workspace           : 'i5-departments',
//
//     tasks               : "i5-tasks",
//
//     folder: "ii5-folder",
//     open_folder: "ii5-folder",
//
//     project: "ii5-project",
//     dev: "ii5-project-dev",
//     sprint: "ii5-sprint",
//     backlog: "ii5-someday-3", someday_3: "ii5-someday-3",
//     tag: "ii5-tag",
//     kanban: "ii5-kanban",
//     scrum: "ii5-agile",
//     files: "ii5-documents",
//
//     mobile: "ii5-device-mobile",
//     desktop: "ii5-device-desktop",
//
//
//     support: "ii5-support",
//     requests: "ii5-archive", archive: "ii5-archive",
//
//
//     api: "ii5-api",
//     qa: "ii5-qa",
//
//     bug: "ii5-bug",
//
//     rocket: "ii5-rocket",
//     megaphone: "ii5-megaphone",
//     idea: "ii5-idea",
//     book: "ii5-book",
//
//     paint: "ii5-paint-bucket",
//
//     money: "ii5-money",
//     contact: "ii5-contact",
//     leads: "ii5-leads",
//
//
//     calendar: "ii5-calendar",
//     cloud: "ii5-cloud",
//     home: "ii5-home",
//     mail_black: "ii5-mail-black",
//     projection_screen: "ii5-projection-screen",
//
//     android: "ii5-social-android", social_android: "ii5-social-android",
//     apple: "ii5-social-apple", social_apple: "ii5-social-apple",
//     windows: "ii5-social-windows", social_windows: "ii5-social-windows",
//
//     education: "ii5-graduation", graduation_cap: "ii5-graduation",
//     assets: "ii5-assets",
//
//     event: "ii5-event",
//
//     img: "ii5-image",
//     inventory: "ii5-inventory",
//     userSearch: "ii5-user-search",
//
//     target: 'ii5-target',
//     taskList: 'ii5-task-list',
//     page: 'ii5-task-list',
//     aim: 'ii5-aim',
//     request: 'ii5-request',
//     request2: 'ii5-request2',
//
//     twitter: 'ii5-social-twitter',
//
//     group       : 'i5-group',
//
//     link            : 'i5-copy-link',
//     embed           : 'i5-embeded-code',
//     facebook        : 'i5-facebook',
//     figma           : 'i5-figma',
//     googleCalendar  : 'i5-google-cal',
//     googleDoc       : 'i5-google-doc',
//     googleMap       : 'i5-google-maps',
//     googleSheet     : 'i5-google-sheet',
//     googleSlides    : 'i5-google-slides',
//     twitterX        : 'i5-twitter',
//     youtube         : 'i5-youtube',
//
//
//     // new View Icons
//
//     'view'                  : 'i5-view',
//     'view-list'             : PROJECT_LIST_CONFIG.icon,
//     'view-table'            : PROJECT_TABLE_CONFIG.icon,
//     'view-board'            : PROJECT_BOARD_CONFIG.icon,
//     'view-calendar'         : PROJECT_CALENDAR_CONFIG.icon,
//     'view-events-summary'   : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.icon,
//     'view-expenses'         : CUSTOM_VIEW_EXPENSES_CONFIG.icon,
//     'view-gantt'            : PROJECT_GANTT_CONFIG.icon,
//     'view-workload'         : PROJECT_WORKLOAD_CONFIG.icon,
//     'view-activity'         : PROJECT_ACTIVITY_CONFIG.icon,
//     'view-what-is-done'     : CUSTOM_VIEW_WHATS_DONE_CONFIG.icon,
//     'view-pastdue'          : CUSTOM_VIEW_PASTDUE_CONFIG.icon,
//     'view-priorities'       : CUSTOM_VIEW_PRIORITIES_CONFIG.icon,
//     'view-action-required'  : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.icon,
//     'view-tasks-by-user'    : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.icon,
//     'view-portfolio'        : PROJECTS_PORTFOLIO_CONFIG.icon,
//     'view-projects-list'    : PROJECTS_PROJECTS_LIST_CONFIG.icon,
//     'view-dashboard'        : CUSTOM_VIEW_DASHBOARD_CONFIG.icon,
//
//
//     // New set
//
//     'law'                   : 'ii5-law'
// }


export const ConstProject = {

    // this should be changed to systemType in future
    type: {
        PROJECT: 1,
        WORKFOLDER: 2,      // old
        FOLDER: 2,          // new
        BACKLOG: 3,
        SPRINT: 4,
        TAG: 5
    },

    systemType: {
        FOLDER: 2,          // project etc
        TAG: 5
    },

    typeList: {
        1: 'Project',
        2: 'Folder',
        3: 'Backlog',
        4: 'Sprint',
        5: 'Tag'
    },

    typeIcon: {
        1: 'ii5-project',
        2: 'ii5-folder',
        3: 'ii5-archive',
        4: 'ii5-sprint',
        5: 'ii5-tag'
    },

    access: {
        READ_ONLY: -10,
        // READ_ONLY_WITH_COMMENT: -9, // just reserve
        CLIENT: -5,

        LIMITED: 1,
        STANDARD: 2,
        FULL: 3
    },

    accessList: {
        1: 'Limited',
        2: 'Standard',
        3: 'Full'
    },

    role: {
        CLIENT: 1,
        GUEST: 2,
        USER: 3,
        PROJECT_MANAGER: 4,
        OWNER: 5
    },

    workfolderStatus: {
        OPEN: 2,
        CLOSED: 5
    },

    workfolderStatusList: {
        2: 'Open',
        5: 'Archived'
    },

    sprintStatus: {
        NOT_STARTED: 1,
        IN_PROGRESS: 2,
        IN_REVIEW: 3,
        COMPLETED: 5
    },

    sprintStatusList: {
        1: 'Planning',
        2: 'Active',
        3: 'Review',
        5: 'Closed'
    },

    // this is depricated ... used in analytics only for d3 charts



    color: {
        0: '858F93',
        1: 'E9536F',
        2: 'E9536F',
        3: 'B738A2',
        4: '735ABF',
        5: '735ABF',
        6: '28A9F0',
        7: '28A9F0',
        8: '28A9F0',
        9: '21AB9B',
        10: '41B45E',
        11: '41B45E',
        12: '41B45E',
        13: '21AB9B',
        14: 'F0B400',
        15: 'FF8F33',
        16: 'FC6F66',
        17: '858F93',
        18: '858F93',
        19: '956B56',
        20: '4E90E4',
        21: '4E90E4',
        22: '735ABF',
        23: '858F93',
        24: '735ABF',
        25: '858F93',
        26: 'E9536F'
    },

    // is it in use ???
    userInheritance: {
        MANUAL      : 0,
        INHERITED   : 1,
        UPHERITED   : 2
    },

    icon        : ProjectIconDictionary,

};
